var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 10.7603C18 14.7504 14.7511 18 10.7619 18C9.18233 18 7.68459 17.4962 6.42349 16.5495C5.96638 16.207 5.87392 15.5581 6.21689 15.1006C6.55988 14.645 7.20902 14.5518 7.66516 14.8944C8.56516 15.5705 9.63714 15.9272 10.7651 15.9272C13.6131 15.9274 15.931 13.609 15.931 10.7603C15.931 7.91162 13.6141 5.59323 10.7651 5.59323C9.13901 5.59388 7.60991 6.37249 6.64009 7.65618H8.68965C9.26088 7.65618 9.72414 8.11888 9.72414 8.69088C9.72414 9.26288 9.26185 9.72559 8.68965 9.72559H4.03448C3.46325 9.72559 3 9.26288 3 8.69088V4.03471C3 3.46271 3.46325 3 4.03448 3C4.60571 3 5.06897 3.46271 5.06897 4.03471V6.30556C6.42996 4.57081 8.49892 3.52091 10.7619 3.52091C14.7511 3.52091 18 6.77021 18 10.7603Z",
    fill: "#849291"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecover);
export default __webpack_public_path__ + "static/media/recover.303a05617275efbc5fbeb03580971228.svg";
export { ForwardRef as ReactComponent };